import { ShippingServicesComponent } from './shipping-services.component';
import { ShippingIntroduceComponent } from './shipping-introduce';
import { ShippingTqComponent } from './shipping-tq';
import { ShippingPaymentComponent } from './shipping-payment';
import { ShippingBuyComponent } from './shipping-buy';

export const routes = [
  { path: '', component: ShippingServicesComponent, children: [
    { path: '', redirectTo: 'gioi-thieu', pathMatch: 'full' },
    { path: 'gioi-thieu', component: ShippingIntroduceComponent },
    { path: 'thanh-toan', component: ShippingPaymentComponent },
    { path: 'tq', component: ShippingTqComponent },
    { path: 'mua', component: ShippingBuyComponent },
  ]},
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shipping-services/shipping-services.routes.ts